export default __webpack_public_path__ + "static/media/003-cherry blossom.81cda5e1.svg";